<script setup lang="ts">
import type { HTMLAttributes } from "vue";

import { cn } from "../../lib/utils";

interface Props {
  class?: HTMLAttributes["class"];
  for?: string;
}

const props = defineProps<Props>();
</script>

<template>
  <label :for="props.for" :class="cn('ui-label', props.class)">
    <slot />
  </label>
</template>
